import * as React from "react";
import { API } from "../API";
import { ChallengeContestor, MedFlytChallengeScreen } from "../components/MedFlytChallengeScreen";
import { Loading, loading } from "../Loading";
import { AppState } from "../system/AppState";

interface MedFlytChallengeActivityProps {
  api: API;
  appState: AppState;
  onBackClick: () => void;
}

interface MedFlytChallengeActivityState {
  referralCode: string | Loading;
  points: number | Loading;
  challengeContestors: ChallengeContestor[] | Loading;
}

export class MedFlytChallengeActivity extends React.Component<
  MedFlytChallengeActivityProps,
  MedFlytChallengeActivityState
> {
  constructor(props: MedFlytChallengeActivityProps) {
    super(props);

    this.state = {
      referralCode: loading(),
      points: loading(),
      challengeContestors: loading(),
    };

    this.loadData();
  }

  loadData() {
    // TODO Error handling!
    // TODO proper unmount handling

    this.props.api.getCaregiverScore().then((score) => {
      this.setState((_prevState: MedFlytChallengeActivityState) => ({
        points: score.score,
      }));
    });

    this.props.api.getTopCaregiverScores().then((scores) => {
      this.setState((_prevState: MedFlytChallengeActivityState) => ({
        challengeContestors: scores.scores.map((value) => ({
          photoUrl: value.photoUrl,
          fullName: value.firstName + " " + value.lastName,
          points: value.score,
        })),
      }));
    });

    this.props.api.getRefCode().then((refCode) => {
      this.setState((_prevState: MedFlytChallengeActivityState) => ({
        referralCode: refCode,
      }));
    });
  }

  componentWillUnmount() {
    // TODO ...
  }

  render() {
    return (
      <MedFlytChallengeScreen
        referralCode={this.state.referralCode}
        points={this.state.points}
        announcementTime={challengeEndTime()}
        challengeContestors={this.state.challengeContestors}
        onBackClick={this.props.onBackClick}
      />
    );
  }
}

function challengeEndTime(): Date {
  const twoWeeks = 60 * 60 * 24 * 14 * 1000;

  let arbitraryEndTime: number = new Date(
    new Date(new Date(new Date(new Date().setMonth(6)).setDate(8)).setHours(0)).setMinutes(0)
  ).setSeconds(0);

  while (new Date().getTime() > arbitraryEndTime) {
    arbitraryEndTime = arbitraryEndTime + twoWeeks;
  }
  return new Date(arbitraryEndTime);
}
